import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  desc?: string;
  moreText?: string;
  morePath?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  moreText,
  morePath,
}: SectionHeadingProps) {
  return (
    <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
      <div>
        <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
          <span className="flex h-3 w-3 items-center justify-center">
            <i className="ri-fire-line text-[11px]"></i>
          </span>
          {eyebrow}
        </span>
        <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          {title}
        </h2>
        {desc && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">{desc}</p>
        )}
      </div>
      {moreText && morePath && (
        <Link
          to={morePath}
          className="group inline-flex shrink-0 items-center gap-1 whitespace-nowrap rounded-full border border-background-300/70 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors duration-200 hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        >
          {moreText}
          <span className="flex h-4 w-4 items-center justify-center transition-transform duration-200 group-hover:translate-x-0.5">
            <i className="ri-arrow-right-line text-sm"></i>
          </span>
        </Link>
      )}
    </div>
  );
}